import { useContext } from 'react'
import { AppContext } from '../../Context'
import { AppRoutes } from './AppRoutes'
import { PublicRoutes } from '../Public'
import { Layout } from '../../components/Layout'
import { PlatformLoader } from '../../components/PlatformLoader'
import { RouteTransition } from '../../components/RouteTransition'

function App() {
  const { isAuth, isLoading, isGlobalLoading } = useContext(AppContext)

  if (isLoading) {
    return <PlatformLoader label="Iniciando Técnica" />
  }

  return (
    <>
      <PlatformLoader
        visible={isGlobalLoading}
        label={isAuth ? "Cargando contenido" : "Validando acceso"}
      />
      {isAuth ? (
        <Layout>
          <RouteTransition>
            <AppRoutes />
          </RouteTransition>
        </Layout>
      ) : (
        <RouteTransition>
          <PublicRoutes />
        </RouteTransition>
      )}
    </>
  )
}

export { App }
